import { createApi } from '@reduxjs/toolkit/query/react'
import axiosBaseQuery from "utils/axios/axiosBaseQuery"
import { DOWNLOAD_CENTER_LIST, DOWNLOAD_FILE, FAVOURITE_TASK, SUPPORT_STAFF_LIST, TASK_PLAN_LIST } from 'config/apiPaths';

export const downloadCenterApi = createApi({
    reducerPath: 'downloadCenterApi',
    baseQuery: axiosBaseQuery({
        baseUrl: "/download-center",
    }),
    tagTypes: ["BulkDownloadReports"],
    endpoints: (builder) => ({
        getDownloadList: builder.query({
            query: ({ page = 1, limit = 10, search = "", sort = { column: "id", direction: "DESC" } }) => ({
                method: "PATCH",
                url: DOWNLOAD_CENTER_LIST,
                data: { page, limit, sort, search }
            }),
            transformResponse: (response) => {
                return response.data;
            },
            providesTags: ["BulkDownloadReports"]
        }),
        downloadFile: builder.query({
            query: ({ id }) => ({
                method: "GET",
                url: `${DOWNLOAD_FILE}/${id}`,
            }),
            transformResponse: (response) => {
                return response.data;
            },
        }),
    }),
})

export const {
    useGetDownloadListQuery,
    useLazyDownloadFileQuery
} = downloadCenterApi;